// AnimationSequencer.jsx
import React, { useState } from 'react';
import AIAnimation from './AIAnimation';
import AIAnimation2 from './AIAnimation2';

export default function AnimationSequencer() {
  const [show, setShow] = useState(1);

  return (
    <div>
      {show === 1
        ? <AIAnimation  onComplete={() => setShow(2)} />
        : <AIAnimation2 onComplete={() => setShow(1)} />
      }
    </div>
  );
}